var installedModules = {};
var moduleToHandlerMapping = {
	9340: {
		getter: () => (__webpack_require__.e(987).then(() => (() => (__webpack_require__(13368))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	10297: {
		getter: () => (Promise.all([__webpack_require__.e(798), __webpack_require__.e(715)]).then(() => (() => (__webpack_require__(86715))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	72088: {
		getter: () => (Promise.all([__webpack_require__.e(798), __webpack_require__.e(106)]).then(() => (() => (__webpack_require__(91106))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	13606: {
		getter: () => (__webpack_require__.e(514).then(() => (() => (__webpack_require__(28133))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	92650: {
		getter: () => (__webpack_require__.e(965).then(() => (() => (__webpack_require__(29965))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	12462: {
		getter: () => (__webpack_require__.e(334).then(() => (() => (__webpack_require__(14953))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	58775: {
		getter: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(74848))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	73884: {
		getter: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(96540))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	22619: {
		getter: () => (__webpack_require__.e(197).then(() => (() => (__webpack_require__(53197))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	88778: {
		getter: () => (__webpack_require__.e(568).then(() => (() => (__webpack_require__(55568))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	58467: {
		getter: () => (Promise.all([__webpack_require__.e(363), __webpack_require__.e(997)]).then(() => (() => (__webpack_require__(74974))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.1.60",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@sravni/react-utils",
	},
	93180: {
		getter: () => (Promise.all([__webpack_require__.e(363), __webpack_require__.e(635)]).then(() => (() => (__webpack_require__(74204))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.2.35",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@sravni/react-icons",
	},
	10486: {
		getter: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(40961))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	42115: {
		getter: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(5338))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	22936: {
		getter: () => (__webpack_require__.e(368).then(() => (() => (__webpack_require__(13368))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^15.1.5",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	61254: {
		getter: () => (__webpack_require__.e(953).then(() => (() => (__webpack_require__(14953))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^15.1.5",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	23004: {
		getter: () => (() => (__webpack_require__(97673))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.3.8",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "@sravni/react-design-system",
	}
};
var initialConsumes = [9340,10297,72088,13606,92650,12462,58775,73884,22619,88778,58467,93180,10486,58775,73884,42115,10486,58467,93180,22936,61254,23004];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"527": [
		9340,
		10297,
		72088,
		13606,
		92650,
		12462,
		58775,
		73884,
		22619,
		88778,
		58467,
		93180,
		10486
	],
	"636": [
		22936,
		61254,
		23004
	],
	"792": [
		58775,
		73884,
		42115,
		10486,
		58467,
		93180
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}